import templateSearch from '../../../../../Template/config/components/selection/Search'
import searchFilter from './SearchFilter'
import tagHierarchy from './tagHierarchy'
export default {
    ...templateSearch,
    searchFilter, 
    tagHierarchy
}



// WEBPACK FOOTER //
// ./src/app/configuration/Insurance/config/components/selection/Search/index.js